// extracted by mini-css-extract-plugin
module.exports = {"prev":"PrevNext-module--prev--3Fhct","next":"PrevNext-module--next--4YDpd","prevNexContainer":"PrevNext-module--prevNexContainer--2ZG6j"};